import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import { cyberpunkColors, glowEffects } from '../../theme/cyberpunkTheme';

// Cyberpunk styled table cell
export const CyberpunkTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    background: `linear-gradient(180deg, ${cyberpunkColors.darkPaper} 0%, ${cyberpunkColors.darkBg} 100%)`,
    color: cyberpunkColors.neonCyan,
    borderBottom: `2px solid ${cyberpunkColors.neonMagenta}`,
    fontFamily: '"Orbitron", sans-serif',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    fontSize: '0.75rem',
    padding: '12px 16px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: cyberpunkColors.textPrimary,
    borderBottom: `1px solid rgba(0, 255, 255, 0.1)`,
    fontFamily: '"Rajdhani", sans-serif',
    padding: '10px 16px',
  },
}));

// Cyberpunk styled table row
export const CyberpunkTableRow = styled(TableRow)(({ theme }) => ({
  transition: 'all 0.2s ease',
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(0, 255, 255, 0.02)',
  },
  '&:hover': {
    backgroundColor: 'rgba(0, 255, 255, 0.08)',
    boxShadow: 'inset 0 0 20px rgba(0, 255, 255, 0.05)',
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

// Cyberpunk styled card
export const CyberpunkCard = styled(Card)(({ theme }) => ({
  background: `linear-gradient(145deg, ${cyberpunkColors.darkPaper} 0%, ${cyberpunkColors.darkCard} 100%)`,
  border: `1px solid rgba(0, 255, 255, 0.2)`,
  boxShadow: '0 0 15px rgba(0, 255, 255, 0.1), inset 0 0 20px rgba(0, 255, 255, 0.02)',
  transition: 'all 0.3s ease',
  '&:hover': {
    borderColor: cyberpunkColors.neonCyan,
    boxShadow: '0 0 25px rgba(0, 255, 255, 0.2), inset 0 0 30px rgba(0, 255, 255, 0.05)',
  },
}));

// Neon text styles for use with sx prop
export const neonTextStyles = {
  cyan: {
    color: cyberpunkColors.neonCyan,
    textShadow: glowEffects.cyanSubtle,
  },
  magenta: {
    color: cyberpunkColors.neonMagenta,
    textShadow: glowEffects.magentaSubtle,
  },
  cyanGlow: {
    color: cyberpunkColors.neonCyan,
    textShadow: glowEffects.cyan,
  },
  magentaGlow: {
    color: cyberpunkColors.neonMagenta,
    textShadow: glowEffects.magenta,
  },
};

// Cyberpunk container styles
export const cyberpunkContainerStyles = {
  border: `1px solid rgba(0, 255, 255, 0.2)`,
  borderRadius: 1,
  background: `linear-gradient(145deg, rgba(26, 26, 36, 0.8) 0%, rgba(10, 10, 15, 0.9) 100%)`,
  boxShadow: '0 0 20px rgba(0, 255, 255, 0.1)',
  padding: 3,
};

// Discount badge colors based on percentage
export const getDiscountColor = (discount) => {
  if (discount >= 70) return cyberpunkColors.neonGreen;
  if (discount >= 50) return cyberpunkColors.neonCyan;
  if (discount >= 30) return cyberpunkColors.neonMagenta;
  return cyberpunkColors.warning;
};
